import { dateConvert } from '../../utils/Helper'
import { useStationHouse } from '../../Hooks/Features/WelcomeKit/useStationHouse';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';

const StationHouse = ({ data, onPrev, readOnly }) => {
  const { inputValue, handleInputChange, handleSubmit, inputFields, inputErrors, showPopup, setShowPopup, welcomekitsubmit, isGeneratingPDF, pdfContentRef, steps, formData } = useStationHouse({ data });


  return (
    <div className='my-2'>
      <h4 className="p-2" style={{ background: "#f2f2f2" }}>Station House Form</h4>
      {
        !readOnly && <form className='my-2' onSubmit={handleSubmit} autoComplete="off">
          <div className='row'>
            {inputFields?.map(({ name, label, type, required }) => (
              <div className="col-4 w100" key={name}>
                <label className="detail-label" htmlFor={name}>
                  {label}
                  {required && <span className="text-danger">*</span>}
                </label>
                <input
                  id={name}
                  name={name}
                  type={type}
                  className="input-dd w100"
                  onChange={handleInputChange}
                  value={inputValue?.[name] || ''}
                />
                {inputErrors?.[name] && (
                  <div className="text-danger">
                    {inputErrors[name]}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className='d-flex justify-content-end my-3'>
            <button className='btn-primary' type="submit">
              Upload
            </button>
          </div>
        </form>
      }

      <div>
        <div>Date: <b>{dateConvert(data?.employee?.joining_date, "day-mon-year")}</b></div>
        <h5 className='my-2'>The Station House Officer form</h5>
        <div className='my-2'>Sub: <b>To verify my details</b></div>
        <div>Sir,</div>
        <div className='my-2'>
          <p>
            My name is <strong>{data?.employee?.user_display_name}</strong> s/o <strong>{inputValue?.station_house_father_name}</strong> and residing at <strong>{inputValue?.residence_place}</strong> for the last <strong>{inputValue?.residence_year}</strong> Years.
          </p>
          <p>I understand that my residence falls under the jurisdiction of your police station.</p>
          <p className='my-2'>
            I have secured a job in SRKAY Consulting Group Pvt. Ltd. and as a term of my appointment, I am supposed to submit a letter / certificate from the relevant police station to state the fact that there has been no criminal case pending / investigated against my name.
          </p>
          <p>
            As this is a critical pre requirement for my job, I hereby submit an application requesting to kindly issue me a certificate confirming that “There has been no criminal case pending / investigated against my name.”
          </p>
          <p className='my-2'>
            I hereby authorize the bearer of this letter to submit the application on my behalf and seek the desired certificate as above said. I shall ever remain obliged.
          </p>
        </div>
        <div className='my-3'>
          <div className='my-1'>Regards,</div>
          <div className='my-1'>Yours Sincerely</div>
          <div className='my-1'><strong>{data?.employee?.user_display_name}</strong></div>
          <div className='my-1'>
            <span>Current Address:- <strong>{inputValue?.residence_place || ""}</strong></span>
          </div>
          <div className='my-1'>
            Confirmed that there has been no criminal case pending against Mr./Ms.<strong>{data?.employee?.user_display_name}</strong> s/o <strong>{inputValue?.station_house_father_name}</strong> and residing at <strong>{inputValue?.residence_place}</strong>  as per the record available to date.
            <p className='my-1'><b>Sign and Seal</b></p>
          </div>
        </div>
      </div>
      {
        !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
          <button className='btn-default' type="button" onClick={onPrev}>Previous</button>
          <button className='btn-primary' type="button" onClick={() => { setShowPopup(true) }}>Submit</button>
        </div>
      }
      <CommanDialog visible={showPopup} message={"Your joining kit has been submitted after confirmation.Please inform to HR regarding this"} handleClose={() => setShowPopup(false)} handleFun={() => { welcomekitsubmit() }} loader={isGeneratingPDF} />

      {
        showPopup && <div ref={pdfContentRef} className='pdf-content' style={{
          fontFamily: 'Arial, sans-serif !important',
          width: '100%'
        }}>
          <div style={{
            backgroundColor: 'white !important',
            color: 'black !important',
            fontFamily: 'Arial, sans-serif !important',
            width: '100%',
            position: 'relative',
            zIndex: 1
          }}>
            {steps.map((val, index) => (
              <div key={index} style={{
                width: '100%',
                maxWidth: '714px',
                margin: '0 auto 20px',
                padding: '5px 10px',
                border: '1px solid #eee',
                borderRadius: '8px',
                boxSizing: 'border-box',
                pageBreakInside: 'avoid',
                breakInside: 'avoid',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word'
              }}>
                <div className='d-flex justify-content-center' style={{ padding: '0' }}>
                  <val.component
                    formData={formData}
                    onChange={() => { }}
                    onNext={() => { }}
                    onPrev={() => { }}
                    isLastStep={false}
                    data={data}
                    label={val.label}
                    readOnly={true}
                  />
                </div>
              </div>
            ))}
          </div>

        </div >
      }

    </div>
  );
};

export default StationHouse;
